import CarrouselArrowIcon from '@/components/Icon/CarrouselArrowIcon'
import ProductCard from '@/components/ProductCard'
import type { Product } from '@/types'
import type { FC } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'

interface Props {
  relatedProductData: Product[]
  relatedProductTitle: string
}
export const RelatedProduct: FC<Props> = ({
  relatedProductData,
  relatedProductTitle,
}: Props) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 5,
    nextArrow: <CarrouselArrowIcon type='next' />,
    prevArrow: <CarrouselArrowIcon type='prev' />,
  }
  const settingsNonSlider: Settings = {
    swipe: false,
    slidesToShow: 5,
    infinite: false,
    variableWidth: false,
    draggable: false,
  }
  return (
    <section className='mb-6 w-full'>
      {relatedProductData && relatedProductData.length > 0 && (
        <>
          <h2 className='mb-5 text-left text-2xl font-bold text-dark-400'>
            {relatedProductTitle}
          </h2>
          <div className='related-product -mx-1'>
            {relatedProductData?.length > 5 ? (
              <Slider {...settings} className='flex gap-2'>
                {relatedProductData &&
                  relatedProductData.map((product: Product) => (
                    <ProductCard
                      key={product._id}
                      product={product}
                      layout={5}
                      className='mx-1'
                      // type={'related-product'}
                    />
                  ))}
              </Slider>
            ) : (
              <Slider
                {...settingsNonSlider}
                className='non-slick ml-0 mr-auto flex'
              >
                {relatedProductData &&
                  relatedProductData.map((product: Product) => (
                    <ProductCard
                      key={product._id}
                      product={product}
                      layout={5}
                      className='mx-1'
                      // type={'related-product'}
                    />
                  ))}
              </Slider>
            )}
          </div>
        </>
      )}
    </section>
  )
}
